import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=995da806&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995da806",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/vercel/path0/components/elements/Section.vue').default})
